(() => {
  const containerId = document.currentScript?.dataset.gtmContainerId;
  if (!containerId || window.nmnGtmScheduled || window.google_tag_manager?.[containerId]) return;

  window.nmnGtmScheduled = true;
  // Preserve queued events while the container waits for the initial page load.
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });

  const loadContainer = () => {
    if (
      window.google_tag_manager?.[containerId] ||
      document.querySelector(`script[src*="googletagmanager.com/gtm.js?id=${containerId}"]`)
    ) return;

    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(containerId)}`;
    document.head.append(script);
  };

  const scheduleContainer = () => {
    // Keep GTM and its tags out of the initial page-load network and rendering work.
    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(loadContainer, { timeout: 2000 });
    } else {
      window.setTimeout(loadContainer, 1500);
    }
  };

  if (document.readyState === "complete") {
    scheduleContainer();
  } else {
    window.addEventListener("load", scheduleContainer, { once: true });
  }
})();
